var map = {
	"./bacon.jpg": "015a",
	"./hamburguesa.jpg": "2dcb",
	"./hawaiano.jpg": "574d",
	"./hotdog.jpg": "45e1",
	"./hotdog_clasico.jpg": "617b",
	"./logo.jpg": "d097",
	"./logo_2.jpg": "6f00",
	"./picada.jpg": "0fcb",
	"./soda.jpg": "b408",
	"./wings.jpg": "fae4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b8e";